"use strict";

module.exports = require("regenerator-transform");


//////////////////
// WEBPACK FOOTER
// ./~/babel-plugin-transform-regenerator/lib/index.js
// module id = 955
// module chunks = 168707334958949